import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';

import { Observable } from 'rxjs';

@Component({
  selector: 'fin-text-toggle-button',
  templateUrl: './text-toggle-button.component.html',
  styleUrls: ['./text-toggle-button.component.scss'],
})
export class TextToggleButtonComponent {
  @Output()
  toggle = new EventEmitter<string>();

  @Input({ required: true })
  name: string;

  @Input({ required: true })
  selected$: Observable<boolean>;

  @Input()
  text: string;

  @Input()
  ariaLabel: string;

  @Input()
  translationPrefix: string;

  @Input()
  ariaPrefix: string;

  constructor(protected elementRef: ElementRef) {}

  onToggle(): void {
    this.toggle.emit(this.name);
    this.elementRef.nativeElement.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
  }
}
